var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.3501C8.54676 16.3501 8.99 15.9069 8.99 15.3601C8.99 14.8134 8.54676 14.3701 8 14.3701C7.45324 14.3701 7.01 14.8134 7.01 15.3601C7.01 15.9069 7.45324 16.3501 8 16.3501Z",
    fill: "#FF7E60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.3501C12.5468 16.3501 12.99 15.9069 12.99 15.3601C12.99 14.8134 12.5468 14.3701 12 14.3701C11.4532 14.3701 11.01 14.8134 11.01 15.3601C11.01 15.9069 11.4532 16.3501 12 16.3501Z",
    fill: "#FF7E60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.3404C16.5468 16.3404 16.99 15.8971 16.99 15.3504C16.99 14.8036 16.5468 14.3604 16 14.3604C15.4532 14.3604 15.01 14.8036 15.01 15.3504C15.01 15.8971 15.4532 16.3404 16 16.3404Z",
    fill: "#FF7E60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.09 9.4502H5.91C3.75057 9.4502 2 11.2008 2 13.3602V18.1002C2 20.2596 3.75057 22.0102 5.91 22.0102H18.09C20.2494 22.0102 22 20.2596 22 18.1002V13.3602C22 11.2008 20.2494 9.4502 18.09 9.4502Z",
    fill: "#FF7E60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 9.45H7.22V7.45C7.22 6.4077 7.63405 5.40809 8.37107 4.67107C9.10809 3.93405 10.1077 3.52 11.15 3.52H12.85C13.8923 3.52 14.8919 3.93405 15.6289 4.67107C16.3659 5.40809 16.78 6.4077 16.78 7.45V9.45H18.09H18.28V7.42C18.2747 5.98242 17.7006 4.60538 16.6832 3.58979C15.6657 2.5742 14.2876 2.00263 12.85 2H11.15C9.71241 2.00263 8.33432 2.5742 7.31685 3.58979C6.29939 4.60538 5.72528 5.98242 5.72 7.42V9.47L5.91 9.45Z",
    fill: "#FF7E60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b25d6a9ccb92ed5155e85b3387af99b4.svg";
export { ForwardRef as ReactComponent };